import { inject } from '@angular/core';
import type { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';
import { of } from 'rxjs';
import { catchError, filter, map, switchMap, take } from 'rxjs/operators';
import { getUserAccountStatus, getUserLoaded } from '../../store';

export const userAccountStatusGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(getUserLoaded).pipe(
    // only pass when user is authenticated
    filter((userIsLoaded) => userIsLoaded),
    // perform necessary loads
    switchMap(() => checkStore(store, router)),
    // else returns observable of false if things have gone awry
    catchError(() => of(false))
  );
};
const checkStore = (store: Store, router: Router): Observable<boolean> => {
  return store.select(getUserAccountStatus).pipe(
    map((accountStatus) => {
      if (accountStatus === 'active') {
        return true;
      } else if (['no_account', 'unknown'].includes(accountStatus)) {
        router.navigate(['/account-link']);
        return false;
      } else if (['inactive', 'locked'].includes(accountStatus)) {
        router.navigate(['/logout']);
        return false;
      } else if (accountStatus === 'no_access') {
        return false;
      }

      return false;
    }),
    take(1)
  );
};
